{
    "Accessibility menu": "无障碍菜单",
    "Close": "关闭",
    "Content adjustments": "内容调整",
    "Navigation adjustments": "导航调整",
    "Text Align": "Text Align",
    "Align Left": "左对齐",
    "Align Center": "Align Center",
    "Align Right": "Align Right",
    "Adjust Font Size": "调整字体大小",
    "Highlight Title": "突出显示标题",
    "Highlight Links": "突出显示链接",
    "Readable Font": "易读字体",
    "Colour adjustments": "颜色调整",
    "Dark Contrast": "深色对比度",
    "Light Contrast": "浅色对比度",
    "High Contrast": "高对比度",
    "High Saturation": "高饱和度",
    "Low Saturation": "低饱和度",
    "Monochrome": "单色",
    "Tools": "工具",
    "Reading Guide": "阅读指南",
    "Big Cursor": "大光标",
    "Increase Font Size": "增大字体",
    "Decrease Font Size": "减小字体",
    "Letter Spacing": "字间距",
    "Line Height": "行高",
    "Font Weight": "字体粗细",
    "Dyslexia Font": "阅读障碍字体",
    "Language": "语言",
    "Accessibility widget": "打开无障碍菜单",
    "Accessibility Profiles": "无障碍配置文件",
    "Cognitive Disability": "认知障碍",
    "Seizure Safe": "癫痫安全",
    "Accessibility statement": "无障碍声明",
    "ADHD": "ADHD",
    "Low Vision": "Low Vision",
    "Pause Animations": "停止动画",
    "Reset all settings": "重置设置",
    "Shortcut:": "Shortcut:",
    "Epilepsy Safe Mode": "Epilepsy Safe Mode",
    "Mute sounds": "Mute sounds",
    "Page read": "Page read",
    "Page read controls": "Page read controls",
    "Pause": "Pause",
    "Resume": "Resume",
    "Stop": "Stop",
    "Settings": "Settings",
    "Speed": "Speed",
    "Voice": "Voice"
}
